// Module
var code = "<div ref=\"loginContainer\" class=\"flex-container-column justify-content-center align-center\">\n</div>";
// Exports
module.exports = code;